/* global $ */

class Accordion {
  constructor($container) {
    this.isOpen = true;
    if ($('body').hasClass('hide-tags')) {
      this.isOpen = false;
    }

    this.$container = $container;
    this.$contents = this.$container.find('.Accordion__contents');
    this.$hideWrap = this.$container.find('.Accordion__hidewrap');
    this.$btn = this.$container.find('.BtnToggleAccordion');

    if (!this.isOpen) {
      this.$hideWrap.css('height', this.$contents.height());
    }

    this.$btn.on('click', () => {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });

    this.$container.addClass('initialized');
  }
  open() {
    if (!this.isOpen) {
      this.isOpen = true;
      $('body').removeClass('hide-tags');
      setTimeout(() => {
        this.$hideWrap.css('height', this.$contents.height());
      }, 30);
    }
  }
  close() {
    if (this.isOpen) {
      this.isOpen = false;
      $('body').addClass('hide-tags');
      setTimeout(() => {
        this.$hideWrap.css('height', this.$contents.height());
      }, 30);
    }
  }
}

export default Accordion;
